import { render, staticRenderFns } from "./CheckRemind.vue?vue&type=template&id=9b5a8f94&scoped=true&"
import script from "./CheckRemind.vue?vue&type=script&lang=js&"
export * from "./CheckRemind.vue?vue&type=script&lang=js&"
import style0 from "./CheckRemind.vue?vue&type=style&index=0&id=9b5a8f94&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5a8f94",
  null
  
)

export default component.exports